/**
 * chartTheme.js — Token-based chart color palette
 * Per CHART_SELECTION_GUIDE: series colors, delta indicators, and shared config.
 */

// Series colors (resolved from CSS custom properties for Recharts which needs hex)
export const CHART_COLORS = {
  primary: 'var(--color-action-primary)',    // red
  secondary: 'var(--color-text-default)',  // black
  tertiary: 'var(--neutral-500)',   // grey
  quaternary: 'var(--navy-800)', // dark navy
};

// Ordered array for multi-series charts
export const SERIES_PALETTE = [
  CHART_COLORS.primary,
  CHART_COLORS.secondary,
  CHART_COLORS.tertiary,
  CHART_COLORS.quaternary,
];

// Delta indicator colors (NOT chart series colors)
export const DELTA_COLORS = {
  positive: 'var(--color-success)', // green
  negative: 'var(--color-error)', // red
  neutral: 'var(--neutral-500)',  // grey
};

// Donut/Pie segment colors for pipeline charts
export const PIPELINE_COLORS = {
  active: CHART_COLORS.primary,    // Red
  sent: CHART_COLORS.secondary,    // Black
  converted: CHART_COLORS.tertiary, // Grey
};

// Shared chart configuration
export const CHART_CONFIG = {
  animationDuration: 300,
  strokeWidth: 2,
  dotRadius: 4,
  activeDotRadius: 6,
  areaOpacity: 0.15,
  fontSize: 12,
  fontFamily: 'var(--font-body, system-ui, sans-serif)',
};

// Axis styling
export const AXIS_STYLE = {
  tick: { fontSize: 11, fill: 'var(--color-text-muted)' },
  axisLine: { stroke: 'var(--neutral-200)' },
  tickLine: false,
};

// Grid styling
export const GRID_STYLE = {
  strokeDasharray: '3 3',
  stroke: 'var(--neutral-100)',
};

const chartThemeExports = {
  CHART_COLORS,
  SERIES_PALETTE,
  DELTA_COLORS,
  PIPELINE_COLORS,
  CHART_CONFIG,
  AXIS_STYLE,
  GRID_STYLE,
};

export default chartThemeExports;
